import React, { useState, useEffect } from "react";
import {
  AppBar,
  Toolbar,
  Box,
  Button,
  Stack,
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
} from "@mui/material";

import { NavLink, Link } from "react-router-dom";
import MenuIcon from "@mui/icons-material/Menu";

import {
  buttonnavbar,
  ButtonNavInferior,
} from "../../theme/button";

import logo from "../../assets/logo/logo.png";
import logocolor from "../../assets/logo/logoblanco.png";

const menu = [
  { label: "Inicio", path: "/" },
  { label: "Quiénes Somos", path: "/quienes-somos" },
  { label: "Horarios", path: "/horarios" },
  { label: "Noticias", path: "/noticias" },
  { label: "Reglamentos", path: "/reglamentos" },
];

export default function NavbarColegio() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 80);
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const closeDrawer = () => {
    setOpen(false);
  };

  return (
    <>
      <AppBar
        position="fixed"
        elevation={scrolled ? 5 : 0}
        sx={{
          backgroundColor: scrolled ? "#8f1515" : "transparent",
          backdropFilter: scrolled ? "blur(10px)" : "none",
          transition: "all 0.4s ease",
          color: scrolled ? "#ffffff" : "#585857",
        }}
      >
        {/* =========================
            PARTE SUPERIOR
        ========================== */}
        <Box
          sx={{
            height: 40,
            display: {
              xs: "none",
              md: "flex",
            },
            justifyContent: "flex-end",
            alignItems: "center",
            px: 5,
          }}
        >
          <Stack direction="row" spacing={2}>
            <Button
              component={Link}
              to="/agenda-comunicaciones"
              sx={{
                ...buttonnavbar,
                color: scrolled ? "#ffffff" : "#ffffff",
                borderColor: scrolled ? "#ffffff" : "#484a75",
              }}
            >
             COMUNIDAD EDUCATIVA
            </Button>

            <Button
              component={Link}
              to="/comunicate-con-nosotros"
              sx={{
                ...buttonnavbar,
                color: scrolled ? "#ffffff" : "#ffffff",
                borderColor: scrolled ? "#ffffff" : "#484a75",
              }}
            >
              CONTÁCTANOS
            </Button>
          </Stack>
        </Box>

        {/* =========================
            MENU PRINCIPAL
        ========================== */}
        <Toolbar
          sx={{
            minHeight: 70,
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          {/* LOGO */}
          <Box
            component={Link}
            to="/"
            sx={{
              display: "flex",
              alignItems: "center",
              textDecoration: "none",
            }}
          >
            <img
              src={scrolled ? logocolor : logo}
              alt="Logo Colegio"
              style={{
                width: 150,
                height: "auto",
                transition: "0.4s",
              }}
            />
          </Box>

          {/* =========================
              MENU DESKTOP
          ========================== */}
         <Stack
  direction="row"
  spacing={1}
  sx={{
    display: {
      xs: "none",
      md: "flex",
    },
    alignItems: "center",
  }}
>
  {menu.map((item) => (
    <Button
      key={item.path}
      component={NavLink}
      to={item.path}
      sx={{
        ...ButtonNavInferior(scrolled),

        color:
          item.label === "Noticias"
            ? "#2e7d32"
            : scrolled
            ? "#ffffff"
            : "#585857",

        transition: "all 0.3s ease",

        "&:hover": {
          color:
            item.label === "Noticias"
              ? "#1b5e20"
              : scrolled
              ? "#c69ba5"
              : "#484a75",
        },
      }}
    >
      {item.label}
    </Button>
  ))}

  


            {/* =========================
                BOTÓN ADMISIÓN
            ========================== */}
            <Button
              component={NavLink}
              to="/admision"
              sx={{
                ml: 1,
                px: 4.5,
                py: 1,
                borderRadius: "22px",
                fontWeight: 700,
                fontSize: "0.85rem",
                color: "#ffffff",
                backgroundColor: "#8f1515",
                boxShadow: "0 4px 12px rgba(143,21,21,0.25)",
                transition: "all 0.3s ease",

                "&:hover": {
                  backgroundColor: "#561c33",
                  transform: "translateY(-2px)",
                  boxShadow: "0 6px 16px rgba(86,28,51,0.35)",
                },
              }}
            >
              ADMISIÓN
            </Button>
          </Stack>

          {/* =========================
              BOTÓN MOBILE
          ========================== */}
          <IconButton
            onClick={() => setOpen(true)}
            sx={{
              display: {
                xs: "flex",
                md: "none",
              },
              color: scrolled ? "#ffffff" : "#484a75",
            }}
          >
            <MenuIcon />
          </IconButton>
        </Toolbar>
      </AppBar>

      {/* =========================
          MENU MOBILE
      ========================== */}
      <Drawer
        anchor="right"
        open={open}
        onClose={closeDrawer}
      >
        <Box
          width={280}
          role="presentation"
          sx={{
            height: "100%",
            backgroundColor: "#ffffff",
          }}
        >
          {/* LOGO */}
          <Box
            component={Link}
            to="/"
            onClick={closeDrawer}
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              textDecoration: "none",
              mt: 3,
              mb: 2,
            }}
          >
            <img
              src={logo}
              alt="Logo Colegio"
              style={{
                width: 130,
                height: "auto",
              }}
            />
          </Box>

          <List>
            {/* MENU PRINCIPAL */}
            {menu.map((item) => (
              <ListItem
                key={item.path}
                disablePadding
                sx={{
                  px: 2,
                  mb: 0.5,
                }}
              >
                <ListItemButton
                  component={NavLink}
                  to={item.path}
                  onClick={closeDrawer}
                  sx={{
                    borderRadius: "12px",
                    color: "#585857",

                    "&:hover": {
                      backgroundColor: "#f2f2f2",
                      color: "#484a75",
                    },
                  }}
                >
                  <ListItemText
                    primary={item.label}
                    primaryTypographyProps={{
                      fontWeight: 600,
                    }}
                  />
                </ListItemButton>
              </ListItem>
            ))}

            {/* =========================
                ADMISIÓN MOBILE
            ========================== */}
            <ListItem
              disablePadding
              sx={{
                px: 2,
                mt: 1,
              }}
            >
              <ListItemButton
                component={NavLink}
                to="/admision"
                onClick={closeDrawer}
                sx={{
                  borderRadius: "14px",
                  backgroundColor: "#8f1515",
                  color: "#ffffff",
                  fontWeight: 700,

                  "&:hover": {
                    backgroundColor: "#561c33",
                  },
                }}
              >
                <ListItemText
                  primary="ADMISIÓN"
                  primaryTypographyProps={{
                    fontWeight: 700,
                  }}
                />
              </ListItemButton>
            </ListItem>

           

            {/* =========================
                AGENDA
            ========================== */}
            <ListItem
              disablePadding
              sx={{
                px: 2,
                mt: 2,
              }}
            >
              <ListItemButton
                component={Link}
                to="/agenda-comunicaciones"
                onClick={closeDrawer}
                sx={{
                  borderRadius: "12px",
                  color: "#484a75",
                  border: "1px solid #484a75",
                }}
              >
                <ListItemText
                  primary="COMUNIDAD EDUCATIVA"
                  primaryTypographyProps={{
                    fontSize: "0.85rem",
                    fontWeight: 600,
                  }}
                />
              </ListItemButton>
            </ListItem>

            {/* =========================
                CONTACTO
            ========================== */}
            <ListItem
              disablePadding
              sx={{
                px: 2,
                mt: 1,
              }}
            >
              <ListItemButton
                component={Link}
                to="/comunicate-con-nosotros"
                onClick={closeDrawer}
                sx={{
                  borderRadius: "12px",
                  color: "#484a75",
                  border: "1px solid #484a75",
                }}
              >
                <ListItemText
                  primary="CONTÁCTANOS"
                  primaryTypographyProps={{
                    fontSize: "0.85rem",
                    fontWeight: 600,
                  }}
                />
              </ListItemButton>
            </ListItem>
          </List>
        </Box>
      </Drawer>
    </>
  );
}

